/** 展示态文本：超过上限截断并追加省略号 */
export function formatRemarkText(remark?: string): string {
  const text = remark ?? "";
  return text.length > 20 ? `${text.slice(0, 20)}…` : text;
}
